import { ImportFilesListConfig } from '@app/routes/index/pending-drawings/index/files/_models';

export class SetImportFilesListConfig {
  static readonly type = '[Import Files List] Set List Config';
  constructor(public config: ImportFilesListConfig) {}
}
